import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTreasure: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTreasure"><Path d="M22 20H17.5V11.5H22V20Z" fill="currentColor"/><Path d="M22 10H17.5V4H18.25C20.3211 4 22 5.67893 22 7.75V10Z" fill="currentColor"/><Path d="M16 10V4H8V10H11.25V9H12.75V10H16Z" fill="currentColor"/><Path d="M11.25 11.5V12.5H12.75V11.5H16V20H8V11.5H11.25Z" fill="currentColor"/><Path d="M6.5 4V10H2V7.75C2 5.67893 3.67893 4 5.75 4H6.5Z" fill="currentColor"/><Path d="M6.5 11.5V20H2V11.5H6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTreasure;
